import React from 'react';
import BaseIcon from './BaseIcon';

class EyeSVG extends BaseIcon {
  render() {
    const { fillColor, height, width } = this.props;
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="xMidYMid"
        width={width}
        height={height}
        viewBox="0 0 60 40"
      >
        <path
          d="M30.000,40.000 C9.352,40.000 0.000,24.658 0.000,20.000 C0.000,15.342 9.352,0.000 30.000,0.000 C50.648,0.000 60.000,15.342 60.000,20.000 C60.000,24.658 50.648,40.000 30.000,40.000 ZM30.000,2.000 C10.683,2.000 2.000,16.309 2.000,20.000 C2.000,23.691 10.683,38.000 30.000,38.000 C49.317,38.000 58.000,23.691 58.000,20.000 C58.000,16.309 49.317,2.000 30.000,2.000 ZM30.000,32.000 C23.383,32.000 18.000,26.617 18.000,20.000 C18.000,13.383 23.383,8.000 30.000,8.000 C36.617,8.000 42.000,13.383 42.000,20.000 C42.000,26.617 36.617,32.000 30.000,32.000 ZM30.000,10.000 C24.486,10.000 20.000,14.486 20.000,20.000 C20.000,25.514 24.486,30.000 30.000,30.000 C35.514,30.000 40.000,25.514 40.000,20.000 C40.000,14.486 35.514,10.000 30.000,10.000 Z"
          fill={fillColor}
          fillRule="evenodd"
        />
      </svg>
    );
  }
}

export default EyeSVG;
